var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMenuLineArrow = function SvgMenuLineArrow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63622 0.351472C9.14012 -0.117157 9.9571 -0.117157 10.461 0.351472L15.6222 5.15147C16.1261 5.6201 16.1261 6.3799 15.6222 6.84853L10.461 11.6485C9.9571 12.1172 9.14012 12.1172 8.63622 11.6485C8.13233 11.1799 8.13233 10.4201 8.63622 9.95147L12.8851 6L8.63622 2.04853C8.13233 1.5799 8.13233 0.820101 8.63622 0.351472Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9675 6.00005C14.9675 5.33731 14.3898 4.80005 13.6772 4.80005H1.29025C0.577636 4.80005 -5.53131e-05 5.33731 -5.53131e-05 6.00005C-5.53131e-05 6.66279 0.577636 7.20005 1.29025 7.20005H13.6772C14.3898 7.20005 14.9675 6.66279 14.9675 6.00005Z",
    fill: "black"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMenuLineArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/menuLineArrow.87f2b416aee9c48cf64b823acbc866e1.svg";